import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { NavigationBarService } from '../navigation-bar.service';
import { CategoryInterface } from 'src/app/interfaces/lobby.interface';
import { ControlHelperService } from 'src/app/services/control/control-helper.service';
import { filter, first, map } from 'rxjs/operators';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Platform } from "@ionic/angular";
import { Device } from '@awesome-cordova-plugins/device/ngx';
import { CommonModule } from '@angular/common';
import { NavigationItemComponent } from '../navigation-item/navigation-item.component';

@UntilDestroy()
@Component({
  selector: 'app-bottom-bar',
  templateUrl: './bottom-bar.component.html',
  styleUrls: ['./bottom-bar.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    NavigationItemComponent
  ]

})
export class BottomBarComponent {

  public activeLink$ = this.controlHepler.activeLobbyCategory$;
  public links$: Observable<CategoryInterface[]>;
  public isAndroid15OrAbove: boolean = false;

  constructor(
    private navigationBarService: NavigationBarService,
    private controlHepler: ControlHelperService,
    private device: Device,
    private platform: Platform,
  ) {
    this.links$ = this.navigationBarService.getNavigationBar('BOTTOM').pipe(
      map(categories => categories?.filter(item => !item.hide_category)));
    this.isAndroid15OrAbove = this.platform.is("android") && parseInt(device.version, 0) >= 15;
  }

  public selectLink(item: CategoryInterface) {
    this.controlHepler.activeLobbyCategory$.pipe(
      first(),
      untilDestroyed(this),
      filter((data: CategoryInterface) => data?.id !== item.id),
    ).subscribe(() => {
      this.navigationBarService.selectLink(item);
    }).unsubscribe();
  }

  public get activeLink(): Observable<any> {
    return this.controlHepler.activeLobbyCategory$;
  }
}
